jQuery(document).ready(async function ($) {
    const totalSlides = 6;
    let currentSlide = 1;
    let selectedCompType = '';
    let selectedCompetitionEvent = '';

    let nfcVehicle = null;
    let vipActive = false;
    let vipAddressConfirmed = false;
    let vipLocationAutocomplete = null;
    let vipSubmitting = false;
    let vipVehicleOptionsLoaded = false;
    let vipSelectedService = null;

    let COMP_EVENTS = [];
    const EVENTS_JSON_URL = 'https://rrzsa.com/myglassevents/events.json';

    // --- Event Mode (generic) ---
    const urlParams = new URLSearchParams(window.location.search);

    // --- NFC / VIP Mode ---
    function getQueryParamCaseInsensitive(paramName) {
        for (const [key, value] of urlParams.entries()) {
            if (key.toLowerCase() === paramName.toLowerCase()) {
                return (value || '').trim();
            }
        }

        return '';
    }

    const nfcId = getQueryParamCaseInsensitive('uid');
    const nfcGuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    const isNfcMode = nfcGuidRegex.test(nfcId);
    // --- End NFC / VIP Mode ---

    const qsEvent = (urlParams.get('event') || '').trim();
    const jsEvent = (window.EVENT_NAME || '').trim();

    // precedence: JS variable wins, otherwise query string
    const eventNameRaw = (jsEvent || qsEvent);
    const eventName = eventNameRaw.toLowerCase();
    const isEventMode = !!eventName;
    // --- End Event Mode ---

    const key = "1B96F9BD-3EB5-42C1-8DAB-13217CD2493D";
    const sec = "My 7918.23M8145.44y";
    const baseServicePath = 'https://service.mgbonline.co.za/MyGlass_Service.svc';
    //const baseServicePath = 'https://devservice.myglassbordereau.co.za/MyGlass_Service.svc';

    const navBar = $('#navigation-bar');
    let allVehicles = {};
    let allAreas = [];
    let selectedClaimType = '';
    let selectedDamageType = '';

    const addressInput = document.getElementById('repairAddress');

    var googleAddressAutocomplete = new google.maps.places.Autocomplete(addressInput, {
        componentRestrictions: { country: 'ZA' },
        fields: ['address_components', 'geometry', 'formatted_address'],
        types: ['address']
    });

    googleAddressAutocomplete.addListener('place_changed', function () {
        var mapResult = GoogleSearchAddressChanged(
            addressInput,
            googleAddressAutocomplete
        );

        if (mapResult != null) {
            $("#selectedAddress").val(mapResult.FormattedAddress);
            $("#repairAddress").val(mapResult.FormattedAddress);
            $('#selectedAddress').trigger('change');
            $('#repairAddress').trigger('input');
        } else {
            $("#selectedAddress").val('');
            $("#repairAddress").val('');
            console.warn("Google Address Search Result was null or invalid.");
        }
    });

    if (isEventMode && !isNfcMode) {
        await loadCompetitionEvents();
    }

    async function loadNfcVehicle() {
        if (!isNfcMode) {
            return null;
        }

        const ajaxUrl =
            (typeof myglassClaims !== 'undefined' && myglassClaims.ajaxUrl)
                ? myglassClaims.ajaxUrl
                : '/wp-admin/admin-ajax.php';

        console.log('MyGlass NFC mode detected.');
        console.log('NFC ID:', nfcId);

        try {
            const response = await $.ajax({
                url: ajaxUrl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'myglass_get_nfc_vehicle',
                    nfcId: nfcId
                }
            });

            if (
                response &&
                response.success === true &&
                response.data
            ) {
                nfcVehicle = response.data;

                console.log(
                    'MyGlass NFC vehicle retrieved:',
                    nfcVehicle
                );

                return nfcVehicle;
            }

            console.warn(
                'MyGlass NFC lookup did not return a vehicle:',
                response
            );

            return null;

        } catch (error) {
            console.warn(
                'MyGlass NFC vehicle lookup failed:',
                error
            );

            return null;
        }
    }
    // -----------------------------------------------
    // Premium NFC guided booking
    // -----------------------------------------------

    function showVipPanel(panel) {
        $('.slide').hide();

        navBar.addClass('hidden');

        $('#nfc-vip').show();

        $('#nfc-vip .nfc-vip-panel')
            .prop('hidden', true)
            .hide();

        $('#nfc-vip [data-vip-panel="' + panel + '"]')
            .prop('hidden', false)
            .show();

        $('#alert-container').empty();

        const vipElement = document.getElementById('nfc-vip');

        if (vipElement && typeof vipElement.scrollIntoView === 'function') {
            vipElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }

    function showNfcVipLoading() {
        showVipPanel('loading');
    }

    function showNfcVipVehicle(vehicle) {
        vipActive = true;

        // Clear previous booking data
        [
            'firstName',
            'lastName',
            'contactNumber',
            'repairAddress',
            'selectedIcon',
            'claimCategory',
            'ddlVehicleMake',
            'ddlVehicleModel',
            'vehicleRegistration',
            'claimFromComp',
            'selectedCompIcon',
            'competitionEvent',
            'brokerageName',
            'brokerEmailAddress'
        ].forEach(name => localStorage.removeItem(name));

        $('#vip-registration').val(
            String(vehicle.VehicleRegistrationNumber || '').trim()
        );

        $('#vip-first-name, #vip-last-name, #vip-phone, #vip-location').val('');

        vipAddressConfirmed = false;

        initializeVipAddress();

        showVipPanel('welcome');
    }

    function vipNormalize(value) {
        return String(value || '')
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }

    function vipAddOption($select, value, label) {
        $select.append(
            $('<option>', {
                value: value,
                text: label || value
            })
        );
    }

    function vipFindOption(values, value) {
        const target = vipNormalize(value);

        return values.find(candidate =>
            vipNormalize(candidate) === target
        ) || '';
    }

    function vipFillModels(make, preferredModel) {
        const $model = $('#vip-model');

        $model.empty();

        vipAddOption($model, '', 'Select model');

        const all = Object.prototype.hasOwnProperty.call(allVehicles, make)
            ? extractModelNames(make)
            : [];

        const models = all.filter(
            name => typeof name === 'string' && name.trim()
        );

        let match = vipFindOption(models, preferredModel);

        models.sort((a, b) => a.localeCompare(b))
            .forEach(name => vipAddOption($model, name));

        // Preserve API model if it is not in the dictionary
        if (!match && preferredModel) {
            match = preferredModel;
            vipAddOption($model, preferredModel);
        }

        vipAddOption($model, '__other__', 'Other / enter manually');

        $model.val(match);

        $('#vip-model-other').toggle(
            $model.val() === '__other__'
        );
    }

    function vipFillMakes() {
        if (!nfcVehicle) return;

        const $make = $('#vip-make');

        $make.empty();

        vipAddOption($make, '', 'Select vehicle make');

        const makes = Object.keys(allVehicles || {});

        let matched = vipFindOption(
            makes,
            nfcVehicle.VehicleMake
        );

        makes.sort((a, b) => a.localeCompare(b))
            .forEach(name => vipAddOption($make, name));

        if (!matched && nfcVehicle.VehicleMake) {
            matched = String(nfcVehicle.VehicleMake).trim();
            vipAddOption($make, matched);
        }

        vipAddOption($make, '__other__', 'Other / enter manually');

        $make.val(matched);

        $('#vip-make-other').hide();

        vipFillModels(
            matched,
            String(nfcVehicle.VehicleModel || '').trim()
        );

        vipVehicleOptionsLoaded = true;
    }

    function loadVipReferenceData() {
        if (Object.keys(allVehicles || {}).length > 0) {
            return Promise.resolve(true);
        }

        return new Promise(resolve => {
            const requestData = {
                apiKey: key,
                authenticationHash: CryptoJS.MD5(
                    key.toLowerCase() + sec
                ).toString()
            };

            makeApiCall(
                'GetRequiredWebsiteClaimFields',
                requestData,

                function (data) {
                    try {
                        allVehicles = JSON.parse(data.VehicleDictionary);
                        allAreas = JSON.parse(data.Areas);

                        resolve(true);
                    } catch (err) {
                        console.warn(
                            'VIP vehicle dictionary could not be parsed.',
                            err
                        );

                        resolve(false);
                    }
                },

                function () {
                    resolve(false);
                }
            );
        });
    }

    function initializeVipAddress() {
        if (vipLocationAutocomplete) return;

        const field = document.getElementById('vip-location');

        if (
            !field ||
            !window.google ||
            !google.maps ||
            !google.maps.places
        ) {
            $('#nfc-vip .nfc-vip-hint').text(
                'Enter your full address.'
            );
            return;
        }

        vipLocationAutocomplete = new google.maps.places.Autocomplete(
            field,
            {
                componentRestrictions: {
                    country: 'ZA'
                },
                fields: ['formatted_address', 'geometry'],
                types: ['address']
            }
        );

        vipLocationAutocomplete.addListener(
            'place_changed',
            function () {
                const place = vipLocationAutocomplete.getPlace();

                if (
                    place &&
                    place.formatted_address &&
                    place.geometry
                ) {
                    $('#vip-location').val(
                        place.formatted_address
                    );

                    vipAddressConfirmed = true;

                    $('#vip-contact-error')
                        .prop('hidden', true)
                        .text('');
                } else {
                    vipAddressConfirmed = false;
                }
            }
        );
    }

    function vipShowError(id, message) {
        $('#' + id)
            .text(message)
            .prop('hidden', false);
    }

    function vipClearError(id) {
        $('#' + id)
            .text('')
            .prop('hidden', true);
    }

    function vipVehicleValues() {
        const makeChoice = $('#vip-make').val();
        const modelChoice = $('#vip-model').val();

        return {
            make: String(
                makeChoice === '__other__'
                    ? $('#vip-make-other').val()
                    : makeChoice || ''
            ).trim(),

            model: String(
                modelChoice === '__other__'
                    ? $('#vip-model-other').val()
                    : modelChoice || ''
            ).trim(),

            registration: String(
                $('#vip-registration').val() || ''
            ).trim().toUpperCase()
        };
    }

    function saveVipVehicle() {
        const values = vipVehicleValues();

        if (
            !values.make ||
            !values.model ||
            !values.registration
        ) {
            vipShowError(
                'vip-vehicle-error',
                'Please confirm your vehicle make, model and registration.'
            );

            return false;
        }

        localStorage.setItem(
            'vehicleRegistration',
            values.registration
        );

        localStorage.setItem(
            'ddlVehicleMake',
            values.make
        );

        localStorage.setItem(
            'ddlVehicleModel',
            values.model
        );

        $('#vehicleRegistration').val(values.registration);

        vipClearError('vip-vehicle-error');

        return true;
    }

    function saveVipContact() {
        const first = String(
            $('#vip-first-name').val() || ''
        ).trim();

        const last = String(
            $('#vip-last-name').val() || ''
        ).trim();

        const phone = String(
            $('#vip-phone').val() || ''
        ).replace(/[\s()-]/g, '').trim();

        const address = String(
            $('#vip-location').val() || ''
        ).trim();

        if (!first || !last) {
            vipShowError(
                'vip-contact-error',
                'Please enter your first name and surname.'
            );

            return false;
        }

        if (!/^\+?\d{10,15}$/.test(phone)) {
            vipShowError(
                'vip-contact-error',
                'Please enter a valid contact number (at least 10 digits).'
            );

            return false;
        }

        if (
            address.length < 6 ||
            (vipLocationAutocomplete && !vipAddressConfirmed)
        ) {
            vipShowError(
                'vip-contact-error',
                'Please select your address from the suggestions.'
            );

            return false;
        }

        localStorage.setItem('firstName', first);
        localStorage.setItem('lastName', last);
        localStorage.setItem('contactNumber', phone);
        localStorage.setItem('repairAddress', address);

        $('#firstName').val(first);
        $('#lastName').val(last);
        $('#contactNumber').val(phone);
        $('#repairAddress').val(address);
        $('#selectedAddress').val(address);

        vipClearError('vip-contact-error');

        return true;
    }

    function vipRestoreSubmit() {
        vipSubmitting = false;

        $('#vip-submit')
            .prop('disabled', !vipSelectedService)
            .text('Request my fitment');
    }

    function applyNfcVehicleToForm() {
        if (!nfcVehicle) {
            return;
        }
        const registration =
            (nfcVehicle.VehicleRegistrationNumber || '')
                .trim();

        const apiMake =
            (nfcVehicle.VehicleMake || '')
                .trim();

        const apiModel =
            (nfcVehicle.VehicleModel || '')
                .trim();

        const ddlMake =
            $('#ddlVehicleMake');

        const ddlModel =
            $('#ddlVehicleModel');


        // -------------------------
        // Registration
        // -------------------------

        if (registration) {
            $('#vehicleRegistration')
                .val(registration);

            localStorage.setItem(
                'vehicleRegistration',
                registration
            );
        }


        // -------------------------
        // Helper used for matching
        // -------------------------

        function normalize(value) {

            return String(value || '')
                .trim()
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();
        }


        // -------------------------
        // Find vehicle make
        // -------------------------

        const availableMakes =
            Object.keys(allVehicles || {});

        let matchedMake =
            availableMakes.find(
                function (make) {
                    return normalize(make) ===
                        normalize(apiMake);
                }
            );


        // More forgiving fallback
        if (!matchedMake && apiMake) {

            matchedMake =
                availableMakes.find(
                    function (make) {

                        return (
                            normalize(make)
                                .includes(
                                    normalize(apiMake)
                                ) ||

                            normalize(apiMake)
                                .includes(
                                    normalize(make)
                                )
                        );
                    }
                );
        }


        // If still not found, add what
        // the NFC API gave us.
        if (!matchedMake && apiMake) {

            ddlMake.append(
                $('<option>', {
                    value: apiMake,
                    text: apiMake
                })
            );

            matchedMake =
                apiMake;
        }


        if (!matchedMake) {
            return;
        }


        ddlMake.val(
            matchedMake
        );

        localStorage.setItem(
            'ddlVehicleMake',
            matchedMake
        );

        ddlMake.trigger(
            'chosen:updated'
        );


        // -------------------------
        // Populate models
        // -------------------------

        ddlModel
            .empty()
            .append(
                '<option value="">--- PLEASE SELECT ---</option>'
            );

        let models = [];

        if (
            allVehicles &&
            allVehicles[matchedMake]
        ) {
            models =
                extractModelNames(
                    matchedMake
                );
        }


        models.forEach(
            function (model) {

                ddlModel.append(
                    $('<option>', {
                        value: model,
                        text: model
                    })
                );
            }
        );


        // -------------------------
        // Find NFC model
        // -------------------------

        let matchedModel =
            models.find(
                function (model) {

                    return normalize(model) ===
                        normalize(apiModel);
                }
            );


        // More forgiving matching
        if (!matchedModel && apiModel) {

            matchedModel =
                models.find(
                    function (model) {

                        return (
                            normalize(model)
                                .startsWith(
                                    normalize(apiModel)
                                ) ||

                            normalize(apiModel)
                                .startsWith(
                                    normalize(model)
                                )
                        );
                    }
                );
        }


        // API model isn't in dictionary.
        // Still allow the known NFC value.
        if (!matchedModel && apiModel) {

            ddlModel.append(
                $('<option>', {
                    value: apiModel,
                    text: apiModel
                })
            );

            matchedModel =
                apiModel;
        }


        if (matchedModel) {

            ddlModel.val(
                matchedModel
            );

            localStorage.setItem(
                'ddlVehicleModel',
                matchedModel
            );
        }


        ddlModel.trigger(
            'chosen:updated'
        );


        console.log(
            'MyGlass NFC vehicle applied to form:',
            {
                registration:
                    registration,

                make:
                    matchedMake,

                model:
                    matchedModel
            }
        );
    }

    function showAlert(message, type, title = '') {
        const alertContainer = $('#alert-container');

        let alertHtml = '';
        let iconSvg = '';
        let alertClasses = '';
        let titleClasses = '';
        let paragraphClasses = '';
        let dismissButtonClasses = '';
        let responseMessage = '';

        if (type === 'success') {
            iconSvg = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 text-green-600">
                               <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                           </svg>`;

            alertClasses =
                'rounded-md border border-gray-300 bg-white p-4 shadow-sm';

            titleClasses =
                'font-medium text-gray-900';

            paragraphClasses =
                'mt-0.5 text-sm text-gray-700';

            responseMessage =
                'Successfully submitted your claim.';

            dismissButtonClasses =
                '-m-3 rounded-full p-1.5 text-gray-500 transition-colors hover:bg-gray-50 hover:text-gray-700';

            title = title || 'Success!';

        } else if (type === 'error') {
            iconSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-5 text-red-700">
                               <path fill-rule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd" />
                           </svg>`;

            alertClasses =
                'border-s-4 border-red-700 bg-red-50 p-4';

            titleClasses =
                'font-medium';

            paragraphClasses =
                'mt-2 text-sm text-red-700';

            dismissButtonClasses =
                '-m-3 rounded-full p-1.5 text-red-700 transition-colors hover:bg-red-100 hover:text-red-900';

            responseMessage =
                'An unexpected error occurred.';

            title = title || 'Something went wrong!';

        } else {
            console.warn("Unsupported alert type:", type);
            return;
        }

        alertHtml = `
            <div role="alert" class="${alertClasses} mb-2 flex items-start gap-4 alert-item">
                <div class="flex-shrink-0">
                    ${iconSvg}
                </div>

                <div class="flex-1">
                    <strong class="${titleClasses}"> ${title} </strong>
                    <p class="${paragraphClasses}">${message}</p>
                </div>

                <button
                    class="${dismissButtonClasses} dismiss-alert-button"
                    type="button"
                    aria-label="Dismiss alert"
                >
                    <span class="sr-only">Dismiss popup</span>

                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-5"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>
            </div>
        `;

        const newAlert = $(alertHtml);

        alertContainer.append(newAlert);

        setTimeout(() => {
            newAlert.fadeOut(300, function () {
                $(this).remove();
            });
        }, 5000);

        newAlert.find('.dismiss-alert-button').on(
            'click',
            function () {
                newAlert.fadeOut(300, function () {
                    $(this).remove();
                });
            }
        );
    }



    function makeApiCall(
        methodName,
        requestData,
        successCallback,
        errorCallback
    ) {
        $('#loader')
            .removeClass('hidden')
            .css('display', 'flex');

        $.ajax({
            url: `${baseServicePath}/${methodName}`,
            type: "POST",
            data: JSON.stringify(requestData),
            contentType: "application/json;charset=utf-8",

            success: function (response) {
                $('#loader').hide();

                let parsedResponse;

                try {
                    if (response && response.RRZResult) {
                        if (
                            typeof response.RRZResult === 'string' &&
                            response.RRZResult.startsWith('<error>')
                        ) {
                            const parser = new DOMParser();

                            const xmlDoc = parser.parseFromString(
                                response.RRZResult,
                                "text/xml"
                            );

                            const errorMessage =
                                xmlDoc
                                    .getElementsByTagName('error')[0]
                                    ?.textContent ||
                                'An unknown API error occurred.';

                            console.error(
                                `API business logic error for ${methodName}: ${errorMessage}`,
                                response
                            );

                            showAlert(
                                `API Error: ${errorMessage}`,
                                "error",
                                "API Error"
                            );

                            if (errorCallback) {
                                errorCallback(
                                    null,
                                    "api_error",
                                    new Error(errorMessage)
                                );
                            }

                            return;

                        } else {
                            parsedResponse =
                                JSON.parse(response.RRZResult);

                            successCallback(parsedResponse);
                        }

                    } else {
                        console.error(
                            `Unexpected API response structure for ${methodName}:`,
                            response
                        );

                        showAlert(
                            "Unexpected server response format.",
                            "error",
                            "Data Error"
                        );

                        if (errorCallback) {
                            errorCallback(
                                null,
                                "invalid_response_structure",
                                new Error(
                                    "Unexpected response structure."
                                )
                            );
                        }
                    }

                } catch (e) {
                    console.error(
                        `JSON Parse Error or other unexpected error for ${methodName}:`,
                        e,
                        response
                    );

                    showAlert(
                        "An unexpected error occurred while processing the server response. Check console for details.",
                        "error",
                        "Data Error"
                    );

                    if (errorCallback) {
                        errorCallback(
                            null,
                            "parseerror",
                            e
                        );
                    }
                }
            },

            error: function (xhr, status, error) {
                $('#loader').hide();

                console.error(
                    `API Error for ${methodName}:`,
                    status,
                    error,
                    xhr
                );

                if (errorCallback) {
                    errorCallback(
                        xhr,
                        status,
                        error
                    );
                } else {
                    showAlert(
                        `Failed to retrieve data for ${methodName}. Please try again.`,
                        "error",
                        "API Call Failed"
                    );
                }
            }
        });
    }

    function updateCompContent(isSuccess) {
        const titleElement = $('#ct-title');
        const messageElement = $('#ct-message');
        const contactElement = $('#ct-contact');

        contactElement.addClass('hidden');

        titleElement.removeClass(
            'text-red-500 text-green-600'
        );

        if (isSuccess) {
            titleElement
                .addClass('text-red-500')
                .text("Thank You!");

            messageElement.text(
                "Your details have been successfully received. Thank you for taking part, and we hope you enjoy the rest of the event."
            );

            contactElement.removeClass('hidden');

        } else {
            titleElement
                .addClass('text-red-500')
                .text("Submission Error");

            messageElement.text(
                "We couldn't process your registration at this time. Please try again."
            );
        }
    }

    function updateSlide6Content(isSuccess) {
        const titleElement = $('#slide6-title');
        const messageElement = $('#slide6-message');
        const contactElement = $('#slide6-contact');
        const retryButton = $('#slide6-retry-button');

        contactElement.addClass('hidden');
        retryButton.addClass('hidden');

        titleElement.removeClass(
            'text-red-500 text-green-600'
        );

        if (isSuccess) {
            titleElement
                .addClass('text-red-500')
                .text("We're All Set");

            messageElement.text(
                "Great Stuff! We've notified our team that you're in need of assistance. They'll be in contact with you shortly."
            );

            contactElement.removeClass('hidden');

        } else {
            titleElement
                .addClass('text-red-500')
                .text("Submission Error");

            messageElement.text(
                "There was an error submitting your information. Please try again."
            );

            retryButton.removeClass('hidden');
        }
    }

    function restoreField(id, type = 'input') {
        const val = localStorage.getItem(id);

        if (val !== null) {
            if (type === 'input') {
                $(`#${id}`).val(val);

            } else if (type === 'select') {
                $(`#${id}`)
                    .val(val)
                    .trigger('chosen:updated');
            }
        }
    }

    function saveField(id, type = 'input') {
        if (type === 'input') {
            localStorage.setItem(
                id,
                $(`#${id}`).val()
            );

        } else if (type === 'select') {
            localStorage.setItem(
                id,
                $(`#${id}`).val()
            );
        }
    }

    function updateDisplayedName() {
        const name =
            localStorage.getItem('firstName') ||
            '&nbsp;';

        $('#slide2 #name').text(name + '!');
        $('#slide3 #name').text(name + '!');
        $('#slide4 #name').text(name + '!');
        $('#slide5 #name').text(name + '!');
    }

    function extractModelNames(make) {
        const modelGroups = allVehicles[make];
        const models = new Set();

        if (Array.isArray(modelGroups)) {
            modelGroups.forEach(group => {
                if (Array.isArray(group)) {
                    group.forEach(modelObj => {
                        const name =
                            modelObj?.Model ||
                            modelObj?.Name ||
                            modelObj?.ModelName;

                        if (name) {
                            models.add(name);
                        }
                    });
                }
            });
        }

        return Array.from(models);
    }

    function toggleBrokerFields(isBroker) {
        if (isBroker === 'yes') {
            $('#broker-fields-wrap')
                .removeClass('hidden');

        } else {
            $('#broker-fields-wrap')
                .addClass('hidden');

            $('#brokerageName')
                .removeClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

            $('#brokerEmailAddress')
                .removeClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

            $('#brokerageName-error')
                .addClass('hidden');

            $('#brokerEmailAddress-error')
                .addClass('hidden');
        }
    }

    function restoreBrokerFields() {
        const isBroker =
            localStorage.getItem('isBroker') || '';

        const brokerageName =
            localStorage.getItem('brokerageName') || '';

        const brokerEmailAddress =
            localStorage.getItem('brokerEmailAddress') || '';

        if (isBroker === 'yes') {
            $('#isBrokerYes').prop(
                'checked',
                true
            );

        } else if (isBroker === 'no') {
            $('#isBrokerNo').prop(
                'checked',
                true
            );
        }

        $('#brokerageName')
            .val(brokerageName);

        $('#brokerEmailAddress')
            .val(brokerEmailAddress);

        toggleBrokerFields(isBroker);
    }

    function populateVehicleMakesAndModels() {
        const ddlMake = $('#ddlVehicleMake');
        const ddlModel = $('#ddlVehicleModel');

        ddlMake
            .empty()
            .append(
                '<option value="">--- PLEASE SELECT ---</option>'
            );

        ddlModel
            .empty()
            .append(
                '<option value="">--- PLEASE SELECT ---</option>'
            );

        if (
            typeof allVehicles === 'object' &&
            allVehicles !== null &&
            Object.keys(allVehicles).length > 0
        ) {
            Object.keys(allVehicles).forEach(make => {
                ddlMake.append(
                    $('<option>', {
                        value: make,
                        text: make
                    })
                );
            });

        } else {
            console.warn(
                "allVehicles data is not available or empty for populating makes."
            );

            showAlert(
                "Vehicle makes could not be loaded. Please try again.",
                "error"
            );
        }

        ddlMake.chosen({
            width: '100%',
            disable_search_threshold: 10,
            placeholder_text_single:
                '--- PLEASE SELECT ---'

        }).trigger("chosen:updated");

        ddlModel.chosen({
            width: '100%',
            disable_search_threshold: 10,
            placeholder_text_single:
                '--- PLEASE SELECT ---'

        }).trigger("chosen:updated");

        ddlMake
            .off('change')
            .on('change', function () {
                const selectedMake =
                    this.value;

                localStorage.setItem(
                    'ddlVehicleMake',
                    selectedMake
                );

                ddlModel
                    .empty()
                    .append(
                        '<option value="">--- PLEASE SELECT ---</option>'
                    );

                if (
                    !selectedMake ||
                    !allVehicles[selectedMake]
                ) {
                    ddlModel.trigger(
                        "chosen:updated"
                    );

                    return;
                }

                const models =
                    extractModelNames(
                        selectedMake
                    );

                models.forEach(name => {
                    ddlModel.append(
                        $('<option>', {
                            value: name,
                            text: name
                        })
                    );
                });

                ddlModel.trigger(
                    "chosen:updated"
                );

                restoreField(
                    'ddlVehicleModel',
                    'select'
                );
            });

        ddlModel
            .off('change')
            .on('change', function () {
                localStorage.setItem(
                    'ddlVehicleModel',
                    this.value
                );
            });

        restoreField(
            'ddlVehicleMake',
            'select'
        );
    }

    function callAddMinimumInfoWebsiteClaimAPI() {
        const methodNameAddClaim =
            'AddMinimumInfoWebsiteClaimV2';

        const claimType =
            localStorage.getItem('selectedIcon') || '';

        const glassDamageType =
            localStorage.getItem('claimCategory') || '';

        let insuredFirstName = '';
        let insuredLastName = '';
        let insuredCellNumber = '';
        let isCompetitionClaim = '';

        const vehicleRegistrationNumber =
            localStorage.getItem('vehicleRegistration') || '';

        const vehicleMake =
            localStorage.getItem('ddlVehicleMake') || '';

        const vehicleModel =
            localStorage.getItem('ddlVehicleModel') || '';

        const buidingAddress =
            encodeURIComponent(
                localStorage.getItem('repairAddress') || ''
            );

        const suburb = 'Admin' || '';

        const competitionEvent =
            localStorage.getItem('competitionEvent') || '';

        const brokerageName =
            localStorage.getItem('brokerageName') || '';

        const brokerEmailAddress =
            localStorage.getItem('brokerEmailAddress') || '';

        const isCompFlow =
            isEventMode &&
            selectedCompType === 'comp';

        if (isCompFlow) {
            insuredFirstName =
                localStorage.getItem('firstNameC') || '';

            insuredLastName =
                localStorage.getItem('lastNameC') || '';

            insuredCellNumber =
                localStorage.getItem('contactNumberC') || '';

            isCompetitionClaim = false;

            console.log(
                "Event comp flow detected, using competition fields for submission.",
                insuredFirstName,
                insuredLastName,
                insuredCellNumber
            );

        } else {
            insuredFirstName =
                localStorage.getItem('firstName') || '';

            insuredLastName =
                localStorage.getItem('lastName') || '';

            insuredCellNumber =
                localStorage.getItem('contactNumber') || '';

            if (eventName === 'pfreechip') {
                insuredLastName =
                    insuredLastName +
                    ' [FREE-CHIP]';
            }

            if (selectedCompType === 'claim') {
                isCompetitionClaim = true;

                console.log(
                    "Should be true",
                    isCompetitionClaim
                );

            } else {
                isCompetitionClaim = '';

                console.log(
                    "Should be empty"
                );
            }
        }

        const currentSelectedClaimType =
            selectedClaimType ||
            localStorage.getItem('selectedIcon') ||
            'vehicle';

        if (
            typeof CryptoJS === 'undefined' ||
            typeof CryptoJS.MD5 === 'undefined'
        ) {
            console.error(
                "CryptoJS library not loaded. Please ensure it's included before calling this function."
            );

            showAlert(
                "Encryption library is missing. Please contact support.",
                "error"
            );

            updateSlide6Content(false);

            return;
        }

        let authenticationHash;

        if (
            currentSelectedClaimType ===
            'building'
        ) {
            authenticationHash =
                key.toLowerCase() +
                isCompetitionClaim +
                claimType +
                glassDamageType +
                insuredFirstName +
                insuredLastName +
                insuredCellNumber +
                buidingAddress +
                suburb +
                sec;

        } else {
            authenticationHash =
                key.toLowerCase() +
                isCompetitionClaim +
                claimType +
                glassDamageType +
                insuredFirstName +
                insuredLastName +
                vehicleRegistrationNumber +
                vehicleMake +
                vehicleModel +
                insuredCellNumber +
                buidingAddress +
                suburb +
                sec;
        }

        console.log(
            "isCompetitionClaim:",
            isCompetitionClaim
        );

        const requestData = {
            apiKey: key,
            isCompetitionClaim:
                isCompetitionClaim,
            claimType:
                claimType,
            glassDamageType:
                glassDamageType,
            insuredFirstName:
                insuredFirstName,
            insuredLastName:
                insuredLastName,
            insuredCellNumber:
                insuredCellNumber,
            buidingAddress:
                buidingAddress,
            suburb:
                suburb,
            eventName:
                competitionEvent,
            brokerageName:
                brokerageName,
            brokerEmailAddress:
                brokerEmailAddress,
            authenticationHash:
                CryptoJS.MD5(
                    authenticationHash
                ).toString()
        };

        if (
            currentSelectedClaimType !==
            'building'
        ) {
            requestData.vehicleRegistrationNumber =
                vehicleRegistrationNumber;

            requestData.vehicleMake =
                vehicleMake;

            requestData.vehicleModel =
                vehicleModel;
        }

        
        makeApiCall(
            methodNameAddClaim,
            requestData,

            function (result) {
                if (
                    result &&
                    !result.IsError
                ) {
                    if (isCompFlow) {
                        updateCompContent(true);

                        showAlert(
                            "Competition entry submitted successfully!",
                            "success",
                            "Entry Submitted"
                        );

                    } else {
                        if (
                            glassDamageType ===
                            'Vehicle Chip Repair'
                        ) {
                            window.location.href =
                                'https://myglass.co.za/thank-you-vehicle-chip-repair/';

                        } else if (
                            glassDamageType ===
                            'Vehicle Glass Replacement'
                        ) {
                            window.location.href =
                                'https://myglass.co.za/thank-you-vehicle-glass-replacement/';

                        } else if (
                            glassDamageType ===
                            'Home & Building'
                        ) {
                            window.location.href =
                                'https://myglass.co.za/thank-you-home-building/';

                        } else {
                            updateSlide6Content(true);

                            showAlert(
                                "Claim submitted successfully!",
                                "success",
                                "Claim Submitted"
                            );
                        }
                    }

                } else {
                    const apiErrorMessage =
                        result?.Message ||
                        'An unknown issue occurred during submission.';

                    if (isCompFlow) {
                        showAlert(
                            `Competition submission failed: ${apiErrorMessage}`,
                            "error",
                            "Entry Failed"
                        );

                        updateCompContent(false);

                    } else {
                        if (vipActive) {
                            vipRestoreSubmit();
                            showVipPanel('service');
                        } else {
                            showSlide(6);
                        }

                        showAlert(
                            `Claim submission failed: ${apiErrorMessage}`,
                            "error",
                            "Submission Failed"
                        );

                        if (!vipActive) {
                            updateSlide6Content(false);
                        }
                    }
                }
            },

            function (
                xhr,
                status,
                error
            ) {
                const debugMessage =
                    `Error submitting data. Status: ${status}, HTTP: ${xhr?.status || 'N/A'}.`;

                if (isCompFlow) {
                    showAlert(
                        debugMessage,
                        "error",
                        "Competion Submission Failed"
                    );

                    updateCompContent(false);

                } else {

                    if (vipActive) {
                        vipRestoreSubmit();
                        showVipPanel('service');
                    } else {
                        showSlide(6);
                    }

                    showAlert(
                        debugMessage,
                        "error",
                        "Claim Submission Failed"
                    );

                    if (!vipActive) {
                        updateSlide6Content(false);
                    }
                }
            }
        );
    }

    async function loadCompetitionEvents() {
        try {
            const ajaxUrl =
                (
                    typeof myglassClaims !== 'undefined' &&
                    myglassClaims.ajaxUrl
                )
                    ? myglassClaims.ajaxUrl
                    : '/wp-admin/admin-ajax.php';

            const response = await fetch(
                `${ajaxUrl}?action=myglass_get_events`,
                {
                    cache: 'no-store'
                }
            );

            if (!response.ok) {
                throw new Error(
                    `HTTP ${response.status}`
                );
            }

            const result =
                await response.json();

            if (
                !result.success ||
                !Array.isArray(result.data)
            ) {
                throw new Error(
                    'Invalid events response.'
                );
            }

            COMP_EVENTS =
                result.data.filter(
                    function (event) {
                        return (
                            event &&
                            event.value &&
                            event.label &&
                            event.active === true
                        );
                    }
                );

        } catch (error) {
            console.error(
                'Failed to load competition events:',
                error
            );

            COMP_EVENTS = [];
        }
    }

    function getCompetitionEvents() {
        return Array.isArray(COMP_EVENTS)
            ? COMP_EVENTS
            : [];
    }

    function setupCompetitionEventSelection() {
        const events =
            getCompetitionEvents();

        const $wrap =
            $('#comp-event-wrap');

        const $select =
            $('#competitionEvent');

        $select.empty();

        if (events.length <= 1) {
            $wrap.addClass('hidden');

            if (events.length === 1) {
                selectedCompetitionEvent =
                    events[0].value;

                localStorage.setItem(
                    'competitionEvent',
                    events[0].value
                );

            } else {
                selectedCompetitionEvent = '';

                localStorage.removeItem(
                    'competitionEvent'
                );
            }

            return;
        }

        $wrap.removeClass('hidden');

        $select.append(
            '<option value="">--- PLEASE SELECT ---</option>'
        );

        events.forEach(
            function (event) {
                $select.append(
                    $('<option>', {
                        value: event.value,
                        text: event.label
                    })
                );
            }
        );

        const savedEvent =
            localStorage.getItem(
                'competitionEvent'
            ) || '';

        if (savedEvent) {
            $select.val(savedEvent);

            selectedCompetitionEvent =
                savedEvent;

        } else {
            selectedCompetitionEvent = '';
        }
    }

    function showCompSlide(compSlide) {
        $('.slide').hide();

        navBar.addClass('hidden');

        if (compSlide === 'comp-signup') {
            $('#comp-signup').show();

            setupCompetitionEventSelection();

            restoreBrokerFields();

        } else if (
            compSlide ===
            'comp-save-contact'
        ) {
            $('#comp-save-contact').show();

        } else if (
            compSlide ===
            'comp-thanks'
        ) {
            $('#comp-thanks').show();
        }
    }

    function showSlide(slideNumber) {
        $('.slide').hide();

        $('#slide' + slideNumber).show();

        currentSlide = slideNumber;

        if (
            slideNumber === 1 ||
            slideNumber === totalSlides
        ) {
            navBar.addClass('hidden');

        } else {
            navBar.removeClass('hidden');
        }

        $('#prev-slide').prop(
            'disabled',
            slideNumber === 1
        );

        $('#next-slide').prop(
            'disabled',
            slideNumber === totalSlides
        );

        if (slideNumber === 2) {
            restoreField('firstName');
            restoreField('lastName');
            updateDisplayedName();

        }else if (slideNumber === 3) {
            populateVehicleMakesAndModels();
            restoreField(
                'vehicleRegistration'
            );
            updateDisplayedName();

            // NFC / VIP vehicle
            if (isNfcMode && nfcVehicle) {
                applyNfcVehicleToForm();
            }
        } else if (slideNumber === 4) {
            restoreField('contactNumber');
            updateDisplayedName();

        } else if (slideNumber === 5) {
            restoreField('repairAddress');
            updateDisplayedName();
        }
    }

    function submitComp() {
        let isValid = true;

        $('#alert-container').empty();

        const firstName =
            $('#firstNameC').val().trim();

        const lastName =
            $('#lastNameC').val().trim();

        const contactNumber =
            $('#contactNumberC').val().trim();

        const events =
            getCompetitionEvents();

        const selectedEvent =
            events.length === 1
                ? events[0].value
                : (
                    $('#competitionEvent')
                        .val() || ''
                ).trim();

        const isBroker =
            $('input[name="isBroker"]:checked')
                .val() || '';

        const brokerageName =
            $('#brokerageName')
                .val()
                .trim();

        const brokerEmailAddress =
            $('#brokerEmailAddress')
                .val()
                .trim();

        const emailPattern =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!firstName) {
            $('#firstNameC')
                .addClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

            $('#firstNameC-error')
                .removeClass('hidden');

            isValid = false;

        } else {
            $('#firstNameC')
                .removeClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

            $('#firstNameC-error')
                .addClass('hidden');
        }

        if (!lastName) {
            $('#lastNameC')
                .addClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

            $('#lastNameC-error')
                .removeClass('hidden');

            isValid = false;

        } else {
            $('#lastNameC')
                .removeClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

            $('#lastNameC-error')
                .addClass('hidden');
        }

        if (
            !contactNumber ||
            !/^\d{10,}$/.test(contactNumber)
        ) {
            $('#contactNumberC')
                .addClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

            $('#contactNumberC-error')
                .text(
                    'Contact number is required. Please use numbers only, without a "+" sign, minimum 10 digits.'
                )
                .removeClass('hidden');

            isValid = false;

        } else {
            $('#contactNumberC')
                .removeClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

            $('#contactNumberC-error')
                .addClass('hidden');
        }

        if (
            events.length > 1 &&
            !selectedEvent
        ) {
            $('#competitionEvent')
                .addClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

            $('#competitionEvent-error')
                .removeClass('hidden');

            isValid = false;

        } else {
            $('#competitionEvent')
                .removeClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

            $('#competitionEvent-error')
                .addClass('hidden');
        }

        if (!isBroker) {
            $('#isBroker-error')
                .removeClass('hidden');

            isValid = false;

        } else {
            $('#isBroker-error')
                .addClass('hidden');
        }

        if (
            isBroker === 'yes' &&
            !brokerageName
        ) {
            $('#brokerageName')
                .addClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

            $('#brokerageName-error')
                .removeClass('hidden');

            isValid = false;

        } else {
            $('#brokerageName')
                .removeClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

            $('#brokerageName-error')
                .addClass('hidden');
        }

        if (
            isBroker === 'yes' &&
            (
                !brokerEmailAddress ||
                !emailPattern.test(
                    brokerEmailAddress
                )
            )
        ) {
            $('#brokerEmailAddress')
                .addClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

            $('#brokerEmailAddress-error')
                .removeClass('hidden');

            isValid = false;

        } else {
            $('#brokerEmailAddress')
                .removeClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

            $('#brokerEmailAddress-error')
                .addClass('hidden');
        }

        if (!isValid) {
            showAlert(
                "Please fill in all required fields to proceed.",
                "error",
                "Validation Error"
            );

            return;
        }

        saveField('firstNameC');
        saveField('lastNameC');
        saveField('contactNumberC');

        selectedCompetitionEvent =
            selectedEvent;

        localStorage.setItem(
            'competitionEvent',
            selectedEvent
        );

        localStorage.setItem(
            'isBroker',
            isBroker
        );

        if (isBroker === 'yes') {
            localStorage.setItem(
                'brokerageName',
                brokerageName
            );

            localStorage.setItem(
                'brokerEmailAddress',
                brokerEmailAddress
            );

        } else {
            localStorage.setItem(
                'brokerageName',
                ''
            );

            localStorage.setItem(
                'brokerEmailAddress',
                ''
            );
        }

        // IMPORTANT:
        // Enter the person immediately when Submit is clicked.
        // Saving the MyGlass contact is optional.
        callAddMinimumInfoWebsiteClaimAPI();

        showCompSlide(
            'comp-save-contact'
        );
    }

    function saveContact() {
        window.location.href =
            'https://rrzsa.com/shared-contacts/My-Glass-Contact.vcf';

        setTimeout(
            () =>
                showCompSlide(
                    'comp-thanks'
                ),
            1500
        );
    }

    function startClaimFromCompetition() {
        localStorage.setItem(
            'claimFromComp',
            '1'
        );

        const firstName =
            (
                localStorage.getItem(
                    'firstNameC'
                ) || ''
            ).trim();

        const lastName =
            (
                localStorage.getItem(
                    'lastNameC'
                ) || ''
            ).trim();

        const cell =
            (
                localStorage.getItem(
                    'contactNumberC'
                ) || ''
            ).trim();

        if (firstName) {
            localStorage.setItem(
                'firstName',
                firstName
            );
        }

        if (lastName) {
            localStorage.setItem(
                'lastName',
                lastName
            );
        }

        if (cell) {
            localStorage.setItem(
                'contactNumber',
                cell
            );
        }

        selectedCompType = 'claim';

        localStorage.setItem(
            'selectedCompIcon',
            'claim'
        );

        showSlide(1);
    }

    function goToNextSlide() {
        let targetSlide =
            currentSlide + 1;

        let isValid = true;

        $('#alert-container').empty();

        if (currentSlide === 2) {
            const firstName =
                $('#firstName')
                    .val()
                    .trim();

            const lastName =
                $('#lastName')
                    .val()
                    .trim();

            if (!firstName) {
                $('#firstName')
                    .addClass(
                        'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                    );

                $('#firstName-error')
                    .removeClass('hidden');

                isValid = false;

            } else {
                $('#firstName')
                    .removeClass(
                        'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                    );

                $('#firstName-error')
                    .addClass('hidden');
            }

            if (!lastName) {
                $('#lastName')
                    .addClass(
                        'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                    );

                $('#lastName-error')
                    .removeClass('hidden');

                isValid = false;

            } else {
                $('#lastName')
                    .removeClass(
                        'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                    );

                $('#lastName-error')
                    .addClass('hidden');
            }

            if (!isValid) {
                showAlert(
                    "Please fill in all required fields to proceed.",
                    "error",
                    "Validation Error"
                );

                return;
            }

            saveField('firstName');
            saveField('lastName');

            if (
                selectedClaimType ===
                'building'
            ) {
                targetSlide = 4;
            }

        } else if (
            currentSlide === 3
        ) {
            const reg =
                $('#vehicleRegistration')
                    .val()
                    .trim();

            const make =
                $('#ddlVehicleMake').val();

            const model =
                $('#ddlVehicleModel').val();

            if (!reg) {
                $('#vehicleRegistration')
                    .addClass(
                        'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                    );

                $('#vehicleRegistration-error')
                    .removeClass('hidden');

                isValid = false;

            } else {
                $('#vehicleRegistration')
                    .removeClass(
                        'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                    );

                $('#vehicleRegistration-error')
                    .addClass('hidden');
            }

            if (!make) {
                $('#ddlVehicleMake_chosen .chosen-single')
                    .addClass(
                        'bg-red-50 border border-red-500 placeholder-red-700'
                    );

                $('#ddlVehicleMake-error')
                    .removeClass('hidden');

                isValid = false;

            } else {
                $('#ddlVehicleMake_chosen .chosen-single')
                    .removeClass(
                        'bg-red-50 border border-red-500 placeholder-red-700'
                    );

                $('#ddlVehicleMake-error')
                    .addClass('hidden');
            }

            if (!model) {
                $('#ddlVehicleModel_chosen .chosen-single')
                    .addClass(
                        'bg-red-50 border border-red-500 placeholder-red-700'
                    );

                $('#ddlVehicleModel-error')
                    .removeClass('hidden');

                isValid = false;

            } else {
                $('#ddlVehicleModel_chosen .chosen-single')
                    .removeClass(
                        'bg-red-50 border border-red-500 text-red-900'
                    );

                $('#ddlVehicleModel-error')
                    .addClass('hidden');
            }

            if (!isValid) {
                showAlert(
                    "Please fill in all required vehicle details.",
                    "error",
                    "Validation Error"
                );

                return;
            }

            saveField(
                'vehicleRegistration'
            );

            saveField(
                'ddlVehicleMake',
                'select'
            );

            saveField(
                'ddlVehicleModel',
                'select'
            );

        } else if (
            currentSlide === 4
        ) {
            const contactNumber =
                $('#contactNumber')
                    .val()
                    .trim();

            if (
                !contactNumber ||
                !/^\d{10,}$/.test(
                    contactNumber
                )
            ) {
                $('#contactNumber')
                    .addClass(
                        'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                    );

                $('#contactNumber-error')
                    .text(
                        'Contact number is required. Please use numbers only, without a "+" sign, minimum 10 digits.'
                    )
                    .removeClass('hidden');

                isValid = false;

            } else {
                $('#contactNumber')
                    .removeClass(
                        'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                    );

                $('#contactNumber-error')
                    .addClass('hidden');
            }

            if (!isValid) {
                showAlert(
                    "Please provide a valid contact number.",
                    "error",
                    "Validation Error"
                );

                return;
            }

            saveField(
                'contactNumber'
            );

        } else if (
            currentSlide === 5
        ) {
            const repairAddress =
                $('#selectedAddress')
                    .val()
                    .trim();

            if (!repairAddress) {
                $('#repairAddress')
                    .addClass(
                        'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                    );

                $('#repairAddress-error')
                    .removeClass('hidden');

                isValid = false;

            } else {
                $('#repairAddress')
                    .removeClass(
                        'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                    );

                $('#repairAddress-error')
                    .addClass('hidden');
            }

            if (!isValid) {
                showAlert(
                    "Please provide your repair address.",
                    "error",
                    "Validation Error"
                );

                return;
            }

            saveField(
                'repairAddress'
            );

            callAddMinimumInfoWebsiteClaimAPI();

            return;
        }

        if (
            targetSlide <=
            totalSlides
        ) {
            showSlide(targetSlide);
        }
    }

    function goToPreviousSlide() {
        let targetSlide =
            currentSlide - 1;

        if (
            currentSlide === 4 &&
            selectedClaimType ===
                'building'
        ) {
            targetSlide = 2;
        }

        if (targetSlide >= 1) {
            showSlide(targetSlide);
        }
    }

    $('#next-slide').on(
        'click',
        goToNextSlide
    );

    $('#prev-slide').on(
        'click',
        goToPreviousSlide
    );

    $('#submit-comp').on(
        'click',
        submitComp
    );

    $('#btn-save-contact').on(
        'click',
        saveContact
    );

    $('#btn-return-to-site').on(
        'click',
        function () {
            window.location.href =
                'https://myglass.co.za';
        }
    );

    $('#btn-log-a-claim').on(
        'click',
        function (e) {
            e.preventDefault();

            startClaimFromCompetition();
        }
    );

    // -------------------------------------------------
    // VIP navigation and event handlers
    // -------------------------------------------------

    $('#nfc-vip-continue').on('click', async function () {
        const $button = $(this);

        $button.prop('disabled', true).text('Preparing...');

        const loaded = await loadVipReferenceData();

        if (!loaded) {
            console.warn(
                'Reference vehicle list unavailable; allowing NFC values and manual override.'
            );
        }

        vipFillMakes();

        showVipPanel('vehicle');

        $button.prop('disabled', false).text('Continue');
    });

    $('#vip-make').on('change', function () {
        const make = $(this).val();

        $('#vip-make-other').toggle(
            make === '__other__'
        );

        vipFillModels(make, '');

        vipClearError('vip-vehicle-error');
    });

    $('#vip-model').on('change', function () {
        $('#vip-model-other').toggle(
            $(this).val() === '__other__'
        );

        vipClearError('vip-vehicle-error');
    });

    $('#vip-vehicle-back').on('click', function () {
        showVipPanel('welcome');
    });

    $('#vip-vehicle-next').on('click', function () {
        if (!saveVipVehicle()) return;

        showVipPanel('contact');
    });

    $('#vip-contact-back').on('click', function () {
        showVipPanel('vehicle');
    });

    $('#vip-location').on('input', function () {
        vipAddressConfirmed = false;
    });

    $('#vip-contact-next').on('click', function () {
        if (!saveVipContact()) return;

        vipSelectedService = null;

        $('#nfc-vip .nfc-vip-service')
            .removeClass('is-selected')
            .attr('aria-pressed', 'false');

        $('#vip-submit').prop('disabled', true);

        showVipPanel('service');
    });

    $('#vip-service-back').on('click', function () {
        showVipPanel('contact');
    });

    $('#nfc-vip .nfc-vip-service').on('click', function () {
        vipSelectedService = {
            claimType: $(this).data('claim-type'),
            damageType: $(this).data('damage-type')
        };

        $('#nfc-vip .nfc-vip-service')
            .removeClass('is-selected')
            .attr('aria-pressed', 'false');

        $(this)
            .addClass('is-selected')
            .attr('aria-pressed', 'true');

        $('#vip-submit').prop('disabled', false);

        vipClearError('vip-service-error');
    });

    $('#vip-submit').on('click', function () {
        if (vipSubmitting) return;

        if (!vipSelectedService) {
            vipShowError(
                'vip-service-error',
                'Please choose a glass service.'
            );
            return;
        }

        if (!saveVipVehicle()) {
            showVipPanel('vehicle');
            return;
        }

        if (!saveVipContact()) {
            showVipPanel('contact');
            return;
        }

        selectedCompType = '';

        selectedClaimType = vipSelectedService.claimType;
        selectedDamageType = vipSelectedService.damageType;

        localStorage.setItem(
            'selectedIcon',
            selectedClaimType
        );

        localStorage.setItem(
            'claimCategory',
            selectedDamageType
        );

        localStorage.removeItem('selectedCompIcon');

        vipSubmitting = true;

        $('#vip-submit')
            .prop('disabled', true)
            .text('Sending your request...');

        // Use the existing MyGlass submission endpoint
        callAddMinimumInfoWebsiteClaimAPI();
    });

    $('#comp-intro .icon').on(
        'click',
        function () {
            localStorage.clear();

            $('#alert-container').empty();

            selectedCompType =
                $(this).data('value');

            console.log(
                'selectedCompType: ' +
                selectedCompType
            );

            localStorage.setItem(
                'selectedCompIcon',
                selectedCompType
            );

            $('#comp-intro .icon')
                .removeClass('selected');

            $(this).addClass(
                'selected'
            );

            if (isEventMode) {
                if (
                    selectedCompType ===
                    'comp'
                ) {
                    const methodNameGetRequiredFields =
                        'GetRequiredWebsiteClaimFields';

                    const authenticationHashGetRequiredFields =
                        key.toLowerCase() +
                        sec;

                    const requestDataGetRequiredFields = {
                        apiKey: key,
                        authenticationHash:
                            CryptoJS.MD5(
                                authenticationHashGetRequiredFields
                            ).toString()
                    };

                    makeApiCall(
                        methodNameGetRequiredFields,
                        requestDataGetRequiredFields,

                        function (RetrievedItem) {
                            allVehicles =
                                JSON.parse(
                                    RetrievedItem.VehicleDictionary
                                );

                            allAreas =
                                JSON.parse(
                                    RetrievedItem.Areas
                                );

                            showCompSlide(
                                'comp-signup'
                            );
                        },

                        function () {
                            showAlert(
                                "Failed to load initial data (vehicle makes/models and repair areas). Please refresh the page and try again.",
                                "error",
                                "Initial Data Error"
                            );
                        }
                    );

                } else {
                    showSlide(1);
                }
            }
        }
    );

    $('#slide1 .icon').on(
        'click',
        function () {
            $('#alert-container').empty();

            const fromComp =
                localStorage.getItem(
                    'claimFromComp'
                ) === '1';

            if (!fromComp) {
                localStorage.clear();

            } else {
                localStorage.removeItem(
                    'firstNameC'
                );

                localStorage.removeItem(
                    'lastNameC'
                );

                localStorage.removeItem(
                    'contactNumberC'
                );

                localStorage.removeItem(
                    'selectedCompIcon'
                );
            }

            selectedClaimType =
                $(this).data('value');

            selectedDamageType =
                $(this).data('type');

            localStorage.setItem(
                'selectedIcon',
                selectedClaimType
            );

            localStorage.setItem(
                'claimCategory',
                selectedDamageType
            );

            localStorage.setItem(
                'selectedCompIcon',
                selectedCompType
            );

            selectedClaimType =
                $(this).data('value');

            selectedDamageType =
                $(this).data('type');

            localStorage.setItem(
                'selectedIcon',
                selectedClaimType
            );

            localStorage.setItem(
                'claimCategory',
                selectedDamageType
            );

            localStorage.setItem(
                'selectedCompIcon',
                selectedCompType
            );

            console.log(
                'selectedCompType: ' +
                selectedCompType
            );

            $('#slide1 .icon')
                .removeClass(
                    'selected'
                );

            $(this).addClass(
                'selected'
            );

            console.log(
                'selectedClaimType: ' +
                selectedClaimType
            );

            console.log(
                'selectedDamageType:' +
                selectedDamageType
            );

            const methodNameGetRequiredFields =
                'GetRequiredWebsiteClaimFields';

            const authenticationHashGetRequiredFields =
                key.toLowerCase() +
                sec;

            const requestDataGetRequiredFields = {
                apiKey: key,
                authenticationHash:
                    CryptoJS.MD5(
                        authenticationHashGetRequiredFields
                    ).toString()
            };

            makeApiCall(
                methodNameGetRequiredFields,
                requestDataGetRequiredFields,

                function (RetrievedItem) {
                    allVehicles =
                        JSON.parse(
                            RetrievedItem.VehicleDictionary
                        );

                    allAreas =
                        JSON.parse(
                            RetrievedItem.Areas
                        );

                    showSlide(2);
                },

                function () {
                    showAlert(
                        "Failed to load initial data (vehicle makes/models and repair areas). Please refresh the page and try again.",
                        "error",
                        "Initial Data Error"
                    );
                }
            );
        }
    );

    $('#firstName').on(
        'input',
        function () {
            localStorage.setItem(
                'firstName',
                this.value
            );

            updateDisplayedName();

            if (
                $(this).val().trim()
            ) {
                $(this).removeClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

                $('#firstName-error')
                    .addClass('hidden');
            }
        }
    );

    $('#lastName').on(
        'input',
        function () {
            localStorage.setItem(
                'lastName',
                this.value
            );

            if (
                $(this).val().trim()
            ) {
                $(this).removeClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

                $('#lastName-error')
                    .addClass('hidden');
            }
        }
    );

    $('#contactNumber').on(
        'input',
        function () {
            localStorage.setItem(
                'contactNumber',
                this.value
            );

            const contactNumber =
                $(this).val().trim();

            $('#contactNumber-error')
                .addClass('hidden');

            if (
                !contactNumber ||
                !/^\d{10,}$/.test(
                    contactNumber
                )
            ) {
                $(this).addClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

            } else {
                $(this).removeClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );
            }
        }
    );

    $('#competitionEvent').on(
        'change',
        function () {
            selectedCompetitionEvent =
                $(this).val() || '';

            localStorage.setItem(
                'competitionEvent',
                selectedCompetitionEvent
            );

            if (
                selectedCompetitionEvent
            ) {
                $('#competitionEvent')
                    .removeClass(
                        'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                    );

                $('#competitionEvent-error')
                    .addClass('hidden');
            }
        }
    );

    $('input[name="isBroker"]').on(
        'change',
        function () {
            const value =
                $(this).val();

            localStorage.setItem(
                'isBroker',
                value
            );

            $('#isBroker-error')
                .addClass('hidden');

            toggleBrokerFields(
                value
            );

            if (value === 'no') {
                localStorage.removeItem(
                    'brokerageName'
                );

                localStorage.removeItem(
                    'brokerEmailAddress'
                );

                $('#brokerageName')
                    .val('');

                $('#brokerEmailAddress')
                    .val('');
            }
        }
    );

    $('#brokerageName').on(
        'input',
        function () {
            localStorage.setItem(
                'brokerageName',
                this.value
            );

            if (
                $(this).val().trim()
            ) {
                $(this).removeClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

                $('#brokerageName-error')
                    .addClass('hidden');
            }
        }
    );

    $('#brokerEmailAddress').on(
        'input',
        function () {
            localStorage.setItem(
                'brokerEmailAddress',
                this.value
            );

            const email =
                $(this).val().trim();

            const emailPattern =
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (
                email &&
                emailPattern.test(email)
            ) {
                $(this).removeClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

                $('#brokerEmailAddress-error')
                    .addClass('hidden');
            }
        }
    );

    $('#selectedAddress').on(
        'change',
        function () {
            localStorage.setItem(
                'repairAddress',
                this.value
            );

            if (
                $(this).val().trim()
            ) {
                $(this).removeClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

                $('#repairAddress-error')
                    .addClass('hidden');
            }
        }
    );

    $('#vehicleRegistration').on(
        'input',
        function () {
            localStorage.setItem(
                'vehicleRegistration',
                this.value
            );

            if (
                $(this).val().trim()
            ) {
                $(this).removeClass(
                    'bg-red-50 border border-red-500 text-red-900 placeholder-red-700'
                );

                $('#vehicleRegistration-error')
                    .addClass('hidden');
            }
        }
    );

    $('#ddlVehicleMake').on(
        'change',
        function () {
            if ($(this).val()) {
                $('#ddlVehicleMake_chosen .chosen-single')
                    .removeClass(
                        'bg-red-50 border border-red-500 text-red-900'
                    );

                $('#ddlVehicleMake-error')
                    .addClass('hidden');
            }
        }
    );

    $('#ddlVehicleModel').on(
        'change',
        function () {
            if ($(this).val()) {
                $('#ddlVehicleModel_chosen .chosen-single')
                    .removeClass(
                        'bg-red-50 border border-red-500 text-red-900'
                    );

                $('#ddlVehicleModel-error')
                    .addClass('hidden');
            }
        }
    );

    $('#slide6-retry-button').on(
        'click',
        function () {
            showSlide(1);

            $('#alert-container')
                .empty();
        }
    );

    updateDisplayedName();

    // ---------------------------------------------------------
    // Initial screen
    // ---------------------------------------------------------

    if (isNfcMode) {
        showNfcVipLoading();
        const vehicle = await loadNfcVehicle();
        
        if (vehicle) {
            showNfcVipVehicle(
                vehicle
            );

        } else {

            console.warn(
                'NFC vehicle could not be loaded. Falling back to normal booking.'
            );

            showAlert(
                'We could not automatically recognise your vehicle, but you can continue with your booking normally.',
                'error',
                'Vehicle Recognition'
            );

            showSlide(1);
        }

    } else if (isEventMode) {
        $('.slide').hide();

        $('#comp-intro').show();

        currentSlide = 0;

        $('#navigation-bar')
            .addClass('hidden');

        localStorage.setItem(
            'eventName',
            eventName
        );

    } else {
        showSlide(1);
    }

    const storedClaimType =
        localStorage.getItem(
            'claimCategory'
        );

    if (storedClaimType) {
        selectedClaimType =
            storedClaimType;

        $(
            `#slide1 .icon[data-type="${selectedClaimType}"]`
        ).addClass(
            'selected'
        );

        localStorage.setItem(
            'claimCategory',
            selectedClaimType
        );
    }
});